import React, { Component } from 'react';
import { Handle, Position, NodeToolbar } from '@xyflow/react';

const emojis = ['🚀', '🔥', '✨'];

class ToolbarNodeInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emoji: '🚀'
    };
  }

  handleDoubleClick = (event) => {
    console.log('ToolbarNode double clicked:', this.props);
    if (this.props.data?.onDoubleClick) {
      this.props.data.onDoubleClick(event, this.props);
    }
  };

  handleEmojiClick = (emoji) => {
    this.setState({ emoji });
    if (this.props.data.onEmojiSelect) {
      this.props.data.onEmojiSelect(emoji);
    }
  };

  render() {
    const { emoji } = this.state;
    const { data } = this.props;

    return (
      <div onDoubleClick={this.handleDoubleClick}>
        <NodeToolbar isVisible>
          {emojis.map((e) => (
            <button
              key={e}
              onClick={() => this.handleEmojiClick(e)}
              aria-label={`Select emoji ${e}`}
            >
              {e}
            </button>
          ))}
        </NodeToolbar>
        <div>
          <div>{emoji}</div>
        </div>
        <Handle type="target" position={Position.Left} className="custom-handle" />
        <Handle type="source" position={Position.Right} className="custom-handle" />
        <div>{data?.label}</div>
      </div>
    );
  }
}

const ToolbarNode = (props) => {
  return <ToolbarNodeInner {...props} />;
};

export default ToolbarNode; 